import { Input, Directive, TemplateRef } from '@angular/core';

@Directive({
      selector: '[bpTab]',
      exportAs: 'bpTab'
})
export class BpTabDirective {
      @Input() title: string;
      @Input() disabled: boolean;

      constructor(public templateRef: TemplateRef<any>) {
      }
}
